"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analogous = analogous;
var color_1 = require("../../color");
/**
 * Generates an analogous color harmony.
 * @param {Color} color - The base color.
 * @param {number} [angle=30] - The angle between colors (default: 30 degrees).
 * @returns {[Color, Color, Color]} An array containing the base color and two analogous colors.
 */
function analogous(color, angle) {
    if (angle === void 0) { angle = 30; }
    var hsl = color.toHsl();
    var color1 = {
        h: (hsl.h + 360 - angle) % 360,
        s: hsl.s,
        l: hsl.l
    };
    var color2 = {
        h: (hsl.h + angle) % 360,
        s: hsl.s,
        l: hsl.l
    };
    return [new color_1.Color(color1), color, new color_1.Color(color2)];
}
